import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonMobile from "../ButtonMobile";

import MenuIcon from "assets/icons/components/menuYellow.svg";
import LogoIcon from "assets/icons/components/logoMobileMain.svg";
import ArrowDownYellow from "assets/icons/components/arrow-down-yellow.svg";
import ArrowUp from "assets/icons/components/arrow-up.svg";
import RadioButton from "../RadioButton";
import { useOutsideAlerter } from "features/game/components/Pagination/CustomSelect";
import BtnMobileIcon from "assets/icons/components/login-btn-header-mobile.png";
import { localStorageKeys } from "config/localStorageKeys";

interface Props {
  isReloadLogo?: boolean;
  isPricingButtonHidden?: boolean;
  onOpen?: () => void;
  showGameMenu?: boolean;
  title?: string;
  onLogin?: () => void;
  onLogo?: () => void;
}

const TopHeaderMobile = ({
  onOpen,
  isReloadLogo,
  isPricingButtonHidden,
  showGameMenu,
  title,
  onLogin,
  onLogo
}: Props) => {
  const navigate = useNavigate();
  const [isActiveDropdown, setIsActiveDropdown] = useState(false);
  const locationNavigation = useLocation();
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, () => {
    setIsActiveDropdown(false);
  });

  const [isAuth, setIsAuth] = useState<boolean | null>(null);
  useEffect(() => {
    const res = localStorage.getItem(localStorageKeys.userInfo);

    setIsAuth(!!res);
  }, []);

  const onClickBtn = useCallback(() => {
    if (showGameMenu) {
      setTimeout(() => {
        setIsActiveDropdown(!isActiveDropdown);
      }, 0);
    } else {
      navigate("/payment");
    }
  }, [isActiveDropdown, showGameMenu, navigate]);

  const textCurrentCourse = useMemo(() => {
    switch (locationNavigation.pathname) {
      case "/by_hand_exercise":
        return "הכרזות";
      case "/by_hand_play_exercise":
        return "משחק יד";
      case "/by_deffence_exercise":
        return "הגנה";
      case "/by_summary":
        return "תקצירים";
      default:
        return "הכרזות";
    }
  }, [locationNavigation.pathname]);

  if (typeof isAuth === "boolean" && !isAuth) {
    return (
      <div ref={wrapperRef}>
        <div className="top-header-mobile">
          <div className="right-container-top-header">
            <img
              src={LogoIcon}
              onClick={() =>
                onLogo ? onLogo() : isReloadLogo ? location.reload() : navigate("/main_page")
              }
            />
          </div>
          <div className="wrapper-btn-login-header-mobile" onClick={onLogin}>
            <img src={BtnMobileIcon} />
            <div className="btn-login-header-mobile">
              <span>התחברות</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div ref={wrapperRef}>
      <div className="top-header-mobile">
        <div className="right-container-top-header">
          <img src={MenuIcon} alt="" onClick={onOpen} />
          <img
            src={LogoIcon}
            onClick={() => (isReloadLogo ? location.reload() : navigate("/main_page"))}
          />
        </div>
        {!!title && <span className="title-mobile-header">{title}</span>}
        {typeof showGameMenu === "boolean" ? (
          <div
            className={
              isActiveDropdown ? "top-header-mobile-dropdown-active" : "top-header-mobile-dropdown"
            }
            onClick={onClickBtn}>
            <ButtonMobile
              style={{ opacity: isPricingButtonHidden ? 0 : 1 }}
              text={showGameMenu ? textCurrentCourse : "לרכישת מנוי"}
              type="underline"
            />
            {showGameMenu && <img className="top-header-mobile-arrow-down" src={ArrowDownYellow} />}
            {showGameMenu && <img className="top-header-mobile-arrow-up" src={ArrowUp} />}
          </div>
        ) : locationNavigation.pathname === "/educational_video" ? (
          <h2 className="heading" style={{ fontWeight: 900, color: "white" }}>
            וידאו והדרכות
          </h2>
        ) : null}
      </div>
      {isActiveDropdown && (
        <div className="top-header-mobile-dropdown-content">
          <RadioButton
            label="הכרזות"
            active={locationNavigation.pathname === "/by_hand_exercise"}
            onClick={() => navigate("/by_hand_exercise")}
          />
          <RadioButton
            label="משחק יד"
            active={locationNavigation.pathname === "/by_hand_play_exercise"}
            onClick={() => navigate("/by_hand_play_exercise?type=handPlay")}
          />
          <RadioButton
            label="הגנה"
            active={locationNavigation.pathname === "/by_deffence_exercise"}
            onClick={() => navigate("/by_deffence_exercise?type=deffense")}
          />
          <RadioButton
            label="תקצירים"
            active={locationNavigation.pathname === "/by_summary"}
            onClick={() => navigate("/by_summary")}
          />
        </div>
      )}
    </div>
  );
};

export default TopHeaderMobile;
